import React from 'react';
import { Outlet } from 'react-router-dom';
import AccountInformationEdit from 'page/Application/MyPagePartnerAdmin/AccountInformation/AccountInformationEdit';
import AccountInformationOverview from 'page/Application/MyPagePartnerAdmin/AccountInformation/AccountInformationOverview';

const AccountInformation = () => {
  return <Outlet />;
};

export default AccountInformation;

export { AccountInformationEdit, AccountInformationOverview };
